import React, { useEffect } from 'react';
import { useVerifyPrev } from 'hooks/AuthHooks';

const Auth = () => {
  /* ===== Data ===== */
  // 나이스 토큰 발급
  const { data: verifyPrev } = useVerifyPrev();

  /* ===== Hooks ===== */
  useEffect(() => {
    if (verifyPrev) {
      const { data: encodeDataToken } = verifyPrev;

      document.form_chk.action =
        'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
      document.form_chk.EncodeData.value = encodeDataToken;
      document.form_chk.target = '_self';
      document.form_chk.submit();
    }
  }, [verifyPrev]);

  /* ===== Render ===== */
  return (
    <>
      <form name="form_chk" method="post" target="_self">
        <input type="hidden" name="m" value="checkplusService"></input>
        <input type="hidden" name="EncodeData" value=""></input>
      </form>
    </>
  );
};

export default Auth;
